export const routes = {
    "/:taskId/managerFeedbackOnReport": {
        title: "Manager Feedback on Report"
    }
};
